import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    checkboxCell: {
      padding: '0 0 0 15px !important',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    linkToInstances: {
      textDecoration: 'none',
      color: palette.blue,
    },
    ButtonContainer: {
      color: palette.red,
      padding: 0,

      '&:hover': {
        opacity: 0.8,
      },
      '&:disabled': {
        color: palette.gray,
        opacity: 0.5,
      },
      '& .MuiIconButton-root': { padding: 0 },
    },

    iconCancel: {
      color: palette.red,
      height: 15,
      width: 15,
      padding: '0px 10%',
      '& .MuiIconButton-root': { padding: 0 },
    },

    rowHeight: { height: 20, '& .MuiTableCell-root': { padding: 0 } },
    icon: {
      height: 15,
      width: 15,
      padding: 0,
      '& .MuiIconButton-root': { padding: 0 },
    },
    removeButton: {
      background: palette.error.main,
      color: palette.error.contrastText,
      marginLeft: 16,
      height: 30,
      padding: '5px 12px',

      '&:hover': {
        background: palette.error.dark,
      },
    },
    tableHeader: {
      padding: '0 !important',
    },
    dateCell: {
      '& .MuiGrid-root': {
        justifyContent: 'center',
      },
    },
  });
